// import * as routesJson from '@/utils/laravelNamedRoutes.json';
import routesCollectionJson from '@/utils/laravelNamedRoutesCollection.json'

const routes = {
  rootUrl: window.location.origin,
  routes: routesCollectionJson,

  route(name, parameters, absolute) {
    const route = this.getByName(name)

    if (!route) {
      throw new Error(`Route [${name}] is not found. Did you export it ?`)
    }

    return this.toRoute(route, parameters, absolute)
  },

  toRoute(route, parameters, absolute) {
    const uri = this.replaceNamedParameters(route.uri, parameters)
    const qs = this.getRouteQueryString(parameters)

    if (absolute && this.isOtherHost(route)) {
      return `//${route.host}/${uri}${qs}`
    }

    return this.getCorrectUrl(uri + qs, absolute)
  },

  isOtherHost(route) {
    return route.host && route.host !== window.location.hostname
  },

  replaceNamedParameters(uri, parameters) {
    let uriWithReplacedParameters = uri.replace(/\{(.*?)\??\}/g, (match, key) => {
      if (parameters?.hasOwnProperty(key)) {
        const value = parameters[key]
        delete parameters[key]
        return value
      }

      return match
    })

    // Strip out any optional parameters that were not given
    uriWithReplacedParameters = uriWithReplacedParameters.replace(/\/\{.*?\?\}/g, '')

    return uriWithReplacedParameters
  },

  getRouteQueryString(parameters) {
    const query = new URLSearchParams(parameters || {}).toString()
    const question = query.length > 0 ? '?' : ''

    return question + query
  },

  getByName(name) {
    return Object.values(this.routes).find((route) => route.name === name)
  },

  getCorrectUrl(uri, absolute) {
    const url = `/${uri.replace(/^\/?/, '')}`

    if (!absolute) {
      return url
    }

    return this.rootUrl.replace('//?$/', '') + url
  },
}

export function laravelNamedRoute(route, parameters, absolute) {
  return routes.route(route, parameters, absolute)
}
